import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
const stage = config[env];
const API_URL = stage.base_url + "/business/";

const addBusiness = (name, link, jwt, fromReview=true) => {
  const headers = { Authorization: "bearer " + jwt };
  return axios.post(API_URL + "create", { name, link }, { headers: headers });
};

const fetch = (id) => {
  // const headers = { Authorization: "bearer " + jwt };
  return axios.get(API_URL + id );
};


// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
  addBusiness,
  fetch,
};
